// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import SimpleSelect from './FormWidgets/SimpleSelect';
import '../../styles/components/FilterPanel.css';

const StyledWrapper = styled.div`
  display: inline-block;
  width: 250px;
  margin-bottom: 15px;
  margin-right: 20px;

  @media (max-width: 768px) {
    width: 120px;
    margin-bottom: 8px;
    margin-right: 10px;
  }
`;

type FilterPanelProps = {
  filters: { name: string; label: string }[];
  onFilterChange: (value: string) => void;
  currentFilter: string;
  style?: React.CSSProperties;
};

export class FilterPanel extends React.PureComponent<FilterPanelProps> {
  render() {
    const { filters, onFilterChange, currentFilter, style } = this.props;

    return (
      <StyledWrapper className='filter-panel' style={style}>
        <SimpleSelect
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          onChange={onFilterChange}
          value={currentFilter}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          data={filters.map(filter => ({
            value: filter.name,
            label: filter.label,
          }))}
        />
      </StyledWrapper>
    );
  }
}
